import React, { useState } from 'react';
import { ChevronRight, Navigation } from 'lucide-react';

const LocationCard = ({ location, isSelected, onClick, isMobile = false, distance }) => {
  const [imageError, setImageError] = useState(false);
  
  // Determine host from the address - Morrisons or Enterprise sites get their logo, others a generic pin
  const address = (location.address || '').toLowerCase();
  const isEnterprise = address.includes('enterprise');
  const isMorrisons = address.includes('morrisons');

  // Standalone sites use their operator's logo, falling back to the generic pin
  const operatingName = (location.operatingName || '').toLowerCase();
  const operatorLogo = operatingName.includes('chirton arc')
    ? '/ChirtonARC.svg'
    : operatingName.includes('page arc')
      ? '/PageARC.svg'
      : '/location-marker-icon.png';

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  const renderIcon = () => {
    if (imageError) {
      // Show red border fallback when any image fails to load
      return (
        <div 
          className="location-marker-icon fallback-icon"
          style={{
            width: '44px',
            height: '44px',
            border: '2px solid #e50000',
            borderRadius: '8px',
            background: 'transparent'
          }}
        />
      );
    } else if (isEnterprise) {
      // Show Enterprise logo for Leeds location
      return (
        <img 
          src="/Enterprise.png" 
          alt="Enterprise Location" 
          className="location-marker-icon"
          onError={handleImageError}
          style={{
            width: '44px',
            height: '44px',
            objectFit: 'cover',
            borderRadius: '8px'
          }}
        />
      );
    } else if (!isMorrisons) {
      // Show operator logo for standalone sites
      return (
        <img
          src={operatorLogo}
          alt={location.operatingName || 'Service Location'}
          className="location-marker-icon"
          onError={handleImageError}
          style={{
            width: '44px',
            height: '44px',
            objectFit: 'cover',
            borderRadius: '8px'
          }}
        />
      );
    } else {
      // Show Morrisons logo for Morrisons locations
      return (
        <img 
          src="/Morrisons.png" 
          alt="Morrisons Location" 
          className="location-marker-icon"
          onError={handleImageError}
          style={{
            width: '44px',
            height: '44px',
            objectFit: 'cover',
            borderRadius: '8px'
          }}
        />
      );
    }
  };

  return (
    <div 
      className={`location-card ${isSelected ? 'location-card-selected' : ''} ${isMobile ? 'location-card-mobile' : ''}`}
      onClick={onClick}
    >
      <div className="location-card-content">
        <div className="location-icon-large">
          {renderIcon()}
        </div>
        
        <div className="location-main">
          <div className="location-info">
            <div className="location-name-section">
              <h3 className="location-name">{location.site}</h3>
              <p className="location-address">
                {location.address}
              </p>
            </div>
            {distance && (
              <div className="location-distance">
                <Navigation size={12} />
                <span>{distance}</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="location-arrow">
          <ChevronRight size={20} className="chevron-icon" />
        </div>
      </div>
      
      {isSelected && !isMobile && (
        <div className="location-selected-indicator"></div>
      )}
    </div>
  );
};

export default LocationCard;